import React from 'react'

import { TTask } from 'redux/hooks/Tasks'
import { SxProps } from '@mui/material'

import { useHistory } from 'react-router-dom'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import TaskPreview, {
  TaskPreviewProps
} from 'components_new/organisms/tasks/TaskPreview'

interface TasksListProps
  extends Pick<
    TaskPreviewProps,
    'editMode' | 'hideLinkedKeyMetric' | 'hideStatus'
  > {
  sx?: SxProps
  tasks: TTask[]
}

const TasksList = (props: TasksListProps) => {
  const { editMode, sx, tasks, ...rest } = props

  const { t } = useTranslation()
  const history = useHistory()

  const handleOpenTask = (id: string) => {
    history.push(`/tasks/${id}`)
  }

  return (
    <Box sx={sx}>
      {tasks.length === 0 ? (
        <EmptyPlaceholder
          background={true}
          body={t('tasks', 'empty_body')}
          size="small"
          title={t('tasks', 'empty_title')}
        />
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {tasks.map((task) => (
            <TaskPreview
              editMode={editMode}
              id={task.id}
              key={task.id}
              onClick={() => handleOpenTask(task.id)}
              onEdit={() => handleOpenTask(task.id)}
              {...rest}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}

export default TasksList
